import SearchResultsPage from "../../components/_/products/index.vue";

new Vue({
	el: "#pages-search-search-content",
	components: { SearchResultsPage }
});
